export default function HomeStatsPlaceholder(): React.ReactElement {
  return (
    <div className="min-h-[220px] pt-6 lg:min-h-[280px] lg:pt-[37px]" aria-hidden>
      <div className="grid grid-cols-2 gap-4 min-[600px]:grid-cols-3 lg:flex lg:gap-0">
        {Array.from({ length: 6 }).map((_, i) => (
          <div key={i} className="h-[52px] bg-white/5 lg:min-w-[140px]" />
        ))}
      </div>
      <div className="mt-6 grid grid-cols-1 gap-6 min-[600px]:grid-cols-2 min-[1200px]:grid-cols-4">
        {Array.from({ length: 4 }).map((_, i) => (
          <div key={i} className="min-h-[160px] bg-white/5" />
        ))}
      </div>
    </div>
  );
}
